var get = require('lodash/get');

module.exports = function isDebugEnabled() {
  const query = get(window, 'location.search', ''); // eslint-disable-line no-undef
  const debugRegex = /debugTuner=true/;
  return !!query.match(debugRegex);
};
